interface TestimonialCardProps {
	name: string;
	company: string;
	testimonial: string;
}

export const TestimonialCard = ({
	name,
	company,
	testimonial,
}: TestimonialCardProps) => {
	return (
		<div className='bg-[rgba(255,208,137,1)] min-w-60 min-h-[195px] w-full max-w-[540px] h-[260px] md:max-h-[300px] px-6 py-8 rounded-xl shadow-none'>
			<div className='flex w-full gap-3 flex-wrap'>
				<div className='overflow-hidden w-10 h-10 rounded-full bg-neutral-800'>
					<div className='w-full h-full flex items-center justify-center text-white font-bold'>
						{name.charAt(0)}
					</div>
				</div>
				<div className='text-[rgba(30,30,30,1)] font-normal leading-[1.4] flex-1'>
					<div className='text-base font-semibold'>{name}</div>
					<div className='text-xs'>{company}</div>
				</div>
			</div>
			<p className='text-base text-[rgba(30,30,30,1)] font-normal leading-[19px] mt-6 py-2'>
				{testimonial}
			</p>
		</div>
	);
};
